import React from 'react';
import './AmbientStage.css';
import heroImg from '../assets/heroimg.png';

function AmbientStage({ children, className = '', image = heroImg }) {
  return (
    <section className={`phone-screen ambient-stage ${className}`}>
      <div className="photo-field" aria-hidden="true">
        <img src={image} alt="" />
      </div>
      <div className="grid-field" aria-hidden="true" />
      <span className="scan-line scan-one" aria-hidden="true" />
      <span className="scan-line scan-two" aria-hidden="true" />
      <div className="grain" aria-hidden="true" />
      {children}
    </section>
  );
}

export default AmbientStage;
